import React from "react";
import { User, FileText, Film, LogOut } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";  // Import SweetAlert2

function VisitorSidebar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Show confirmation dialog using SweetAlert2
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to log out.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, log out",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // Clear localStorage
        localStorage.removeItem("cust_id");
        localStorage.removeItem("cust_email");

        // Navigate to login page
        navigate("/customer/login");
      }
    });
  };

  return (
    <div className="sidebar-container-visitor hide-on-mobile">
      <div className="sidebar-links">
        {/* <Link className="sidebar-item">
          <User className="sidebar-icon" />
          <span className="sidebar-label">Dashboard</span>
        </Link> */}

        <Link to="/my-inquiry" className="sidebar-item">
          <FileText className="sidebar-icon" />
          <span className="sidebar-label">My Inquiries</span>
        </Link>
        <Link to="/my-orders" className="sidebar-item">
          <FileText className="sidebar-icon" />
          <span className="sidebar-label">My Order</span>
        </Link>
 
 

         
        {/* <Link to="/shipping-address" className="sidebar-item">
          <User className="sidebar-icon" />
          <span className="sidebar-label">My Shipping Address</span>
        </Link> */}

        <Link to="/customer/profile" className="sidebar-item">
          <User className="sidebar-icon" />
          <span className="sidebar-label">My Account</span>
        </Link>


         <Link to="/address-management" className="sidebar-item">
          <User className="sidebar-icon" />
          <span className="sidebar-label">Address Management</span>
        </Link>


        <Link to="/change-password" className="sidebar-item">
          <User className="sidebar-icon" />
          <span className="sidebar-label">Change Password</span>
        </Link>


        
        <div className="sidebar-item" onClick={handleLogout}>
          <LogOut className="sidebar-icon" />
          <span className="sidebar-label">Logout</span>
        </div>
      </div>
    </div>
  );
}

export default VisitorSidebar;
